/**
 * 预警监控 API 服务
 * 负责与后端接口交互，获取库存/资金预警数据
 */
import request from '@/utils/request'
import { generateSign, generateRequestId } from '@/utils/sign'

/** API 配置常量 */
var API_CONFIG = {
  url: '/supplier/supplier/queryAvailableInfo',
  md5Key: 'ctai80cfbk67k4ojhkzqnnytsbvtuyo3'
}

/** 省份列表 */
export var PROVINCE_LIST = ['全国', '湖北省', '湖南省', '广东省', '北京市', '上海市']

/**
 * 查询可用库存/资金信息
 *
 * @param {Object} options - 查询参数
 * @param {string} options.appid - 应用ID（从URL参数获取）
 * @param {string} options.deductModel - 扣减模式：'0'-库存(电子券), '1'-资金(资金池)
 * @param {string} options.provinceName - 省份名称
 * @returns {Promise<Array>} 预警数据列表
 */
export function queryAvailableInfo(options) {
  var timestamp = Date.now()
  var requestId = generateRequestId()

  var params = {
    appid: options.appid,
    deductModel: options.deductModel,
    provinceName: options.provinceName,
    requestId: requestId,
    timestamp: timestamp
  }

  params.sign = generateSign(params, API_CONFIG.md5Key)

  return request({
    url: API_CONFIG.url,
    method: 'post',
    data: params
  })
}
